module.exports = __webpack_public_path__ + "static/91-c50630cf4f3d9ddc57b8910348b1f9ed.png";